module.exports = __webpack_public_path__ + "img/btn_menu_js_c.0ee3f543.png";